// extracted by mini-css-extract-plugin
module.exports = {"control":"StaysCheckout_control__jdDVO","wrapper":"StaysCheckout_wrapper__3jpvz","confirm":"StaysCheckout_confirm__PR1GA","price":"StaysCheckout_price__3fA1q"};